import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import i18n from "../../../../constants/i18n";
import { ONE_O_ONE_C_FILTER } from "../../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";
import getKhattabat101CGeneralStore from "../../../../stores/khattabat-stores/101c-stores/101c-general-store";
import getKhattabatFilterStore from "../../../../stores/khattabat-stores/filter-store";
import getKhattabatSelectsStore from "../../../../stores/khattabat-stores/selects-store";
import { E_CLIENT_PAGE, TClientPageType } from "../../../../Types";
import KhattabatAiFilter from "../filter/ai-filter/KhattabatAiFilter";
import KhattabatFilterMultiSelect from "../filter/KhattabatFilterMultiSelect";

const KhattabatClientsHeader = withLiteObserverAndTheme(() => {
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();
  const { getClientPageType, setClientPageType } =
    getKhattabat101CGeneralStore();
  const {
    filterSelectedTypes,
    setFilterSelectedTypes,
    isSearchingClients,
    isActiveFilter,
    resetFilters,
    handleFiltering
  } = getKhattabatFilterStore();

  if (isAiKhattaba) {
    return <KhattabatAiFilter />;
  }

  const clientPageType = getClientPageType.get();

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Tabs
        value={clientPageType}
        onChange={(_, value: TClientPageType) => setClientPageType(value)}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab value={E_CLIENT_PAGE.ALL} label={i18n.get("ALL_CLIENTS")} />
        <Tab
          value={E_CLIENT_PAGE.BREACHE_LEVEL}
          label={i18n.get("REQUIRES_ATTENTION")}
        />
      </Tabs>
      {clientPageType !== E_CLIENT_PAGE.ALL ? null : (
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
        >
          <Stack sx={{ minWidth: 240, flex: 1, maxWidth: 480 }}>
            <KhattabatFilterMultiSelect
              label={i18n.get("FILTERS")}
              options={ONE_O_ONE_C_FILTER}
              value={filterSelectedTypes.get()}
              onChange={(value) => {
                getKhattabatSelectsStore().initializeAndClearMarksStateWithClients(
                  "clientPage"
                );
                setFilterSelectedTypes(value);
              }}
            />
          </Stack>
          <Button
            variant="outlined"
            color="error"
            disabled={!isSearchingClients.get()}
            onClick={resetFilters}
          >
            {i18n.get("FILTERS_RESET")}
          </Button>
          <Button
            variant="contained"
            disabled={!isActiveFilter.get()}
            onClick={handleFiltering}
          >
            {i18n.get("APPLY")}
          </Button>
        </Stack>
      )}
    </Stack>
  );
});

export default KhattabatClientsHeader;
